import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { VideoDto } from '../../../models/trofaco/videoDto';
import { defer, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VideoService {

    constructor(private requestService: RequestService) { }

    async addVideo(areaId: string, dto: VideoDto): Promise<any> {
        let data = {
            plantingSiteAreaId: areaId,
            title: dto.title,
            videoUrl: dto.videoUrl,
            description: dto.description,
            date: dto.date
        };
        let result = await this.requestService.post('videos', data);
        return result.data;
    }

    updateVideo(dto: VideoDto) 
    {   
        return this.requestService.patch('videos', dto);
    }

    deleteVideo(videoId: string) {
        return this.requestService.delete(`videos/${videoId}`);
    }
}
